var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-item smooth-trans",on:{"click":function($event){return _vm.$emit('jump-to-profile',_vm.contact.uid)}}},[_c('p',{staticClass:"unSelectable"},[_vm._v(_vm._s(_vm.contact.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }